import { forwardRef } from 'react';

import {
    TagButton,
    TagButtonText,
    TagWrapper,
} from '@domains/new-conversation/molecules/TagSelector/TagSelector.styled';

interface Option {
    disabled?: boolean;
    label: string;
    value: string;
}

interface TagSelectorProps {
    onChange: (key: string) => void;
    options: Option[];
    value?: string;
}

export const TagSelector = forwardRef<HTMLDivElement, TagSelectorProps>(
    ({ onChange, options, value }, ref) => {
        return (
            <TagWrapper ref={ref}>
                {options.map((item, index) => {
                    const isActive = value === item.value;
                    return (
                        <TagButton
                            active={isActive}
                            disabled={!!item?.disabled}
                            key={index}
                            onClick={() => onChange(item.value)}
                        >
                            <TagButtonText
                                active={isActive}
                                disabled={item?.disabled}
                            >
                                {item.label.toUpperCase()}
                            </TagButtonText>
                        </TagButton>
                    );
                })}
            </TagWrapper>
        );
    },
);
